import {
  toReactNodes
} from "./chunk-3NZOR3KT.js";
import {
  StyledLabelModerate,
  getPropDefaults
} from "./chunk-2Y4B6XYK.js";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-CWMXXUWU.js";

// src/components/typography/LabelModerate.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function LabelModerate(props) {
  const propsWithDefaults = getPropDefaults(props);
  let reactNodes = props.children || null;
  if (props.content) {
    reactNodes = toReactNodes(props.content);
  }
  return /* @__PURE__ */ jsx(StyledLabelModerate, __spreadProps(__spreadValues({}, propsWithDefaults), { children: reactNodes }));
}

export {
  LabelModerate
};
